import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../reducers';
import { EditData, fetchData, fetchneedData } from '../reduxactions/organizationactions/OrgEditNeedsActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { useLocation, useParams } from 'react-router-dom';

const OrgEditNeeds = () => {

    interface NeedData {
        Id: string; // Change the type accordingly
        needtype: string; // Change the type accordingly
    }
    const [needsadd, setneedsadd] = useState(false);
    const [needIds, setNeedIds] = useState('');
    const [needtype, setNeedType] = useState<string>('');


    const [datas, setData] = useState<NeedData[]>([]);
    const [selectedNeed, setSelectedNeed] = useState<NeedData | null>(null);

    const [needId, setNeedId] = useState('');
    const [needtittle, setName] = useState('');
    const [budget_amount, setAmount] = useState('');
    const [description, setDescription] = useState('');

    const [needstype, setNeedstype] = useState('needs'); // Assuming 'Needs' is the initial value
    const navigate = useNavigate();


    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('')
    const location = useLocation();
    const [queryParams, setQueryParams] = useState(null);

    const viewdata = useSelector((state: RootState) => state.orgeditneed.viewdata);
    const data = useSelector((state: RootState) => state.orgeditneed.data);
    const editdata = useSelector((state: RootState) => state.orgeditneed.editdata);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("Id") as any);
    }, [location]);
    const { Id } = useParams();

    useEffect(() => {
        if (viewdata.length > 0) {
            setSelectedNeed(viewdata[0].needtype);
            setName(viewdata[0].needtittle);
            setAmount(viewdata[0].budget_amount);
            setDescription(viewdata[0].description);

        }

    }, [viewdata]);

    const dispatch = useDispatch();
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchData() as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    const fetchNeedsDataAsync = async () => {
        try {
            await dispatch(fetchneedData(Id) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }
    //To dispatch add data to dashboardaction.ts

    const AddNeeds = async () => {

        try {
            await dispatch(EditData(Id, uid, selectedNeed, needtittle, budget_amount, description) as any);
            console.error(selectedNeed)
            const url = `/orgneeds`;
            navigate(url);
        } catch (error) {
            console.error('Error applying :', error);
        }



    };

    useEffectOnce(() => {
        fetchDataAsync();
        fetchNeedsDataAsync();

    }, [dispatch]);
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/org-editneeds.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Edit Needs</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <Panel>
                            <div className="container-fluid">
                                {viewdata.map((response: any) =>
                                        <div className="grid">
                                            <div className="col-12 md:col-6">
                                                <Panel header="Edit Needs" className="shadow-1">
                                                    <div className="p-fluid">
                                                        {/* Need Type */}
                                                        <div className="field grid mb-4">
                                                            <label className="block text-800 font-semibold mb-2">
                                                                Need Type
                                                            </label>

                                                            <Dropdown
                                                                data-testid="edit-needtype-select"
                                                                value={selectedNeed || (viewdata.length > 0 && viewdata[0].needtype)}
                                                                onChange={(e) => setSelectedNeed(e.value)}
                                                                options={data}
                                                                optionLabel="needtype"
                                                                optionValue="Id"
                                                                placeholder="Select Need Type"
                                                                className="w-full"
                                                            />
                                                        </div>

                                                        {/* Need Title */}
                                                        <div className="field grid mb-4">
                                                            <label className="block text-800 font-semibold mb-2">
                                                                Need Title
                                                            </label>

                                                            <InputText
                                                                id="name"
                                                                data-testid="edit-title-input"
                                                                type="text"
                                                                placeholder="Need Title"
                                                                className="w-full"
                                                                value={needtittle}
                                                                onChange={(e) => setName(e.target.value)}
                                                            />
                                                        </div>

                                                        {/* Budget Amount */}
                                                        <div className="field grid mb-4">
                                                            <label className="block text-800 font-semibold mb-2">
                                                                Budget Amount
                                                            </label>

                                                            <InputText
                                                                id="amount"
                                                                type="number"
                                                                data-testid="edit-amount-input"
                                                                placeholder="Enter Budget Amount"
                                                                className="w-full"
                                                                name="budget_amount"
                                                                value={budget_amount}
                                                                onChange={(e) => setAmount(e.target.value)}
                                                            />
                                                        </div>

                                                        {/* Description */}
                                                        <div className="field grid mb-4">
                                                            <label className="block text-800 font-semibold mb-2">
                                                                Description
                                                            </label>

                                                            <InputTextarea
                                                                id="text"
                                                                rows={4}
                                                                data-testid="edit-desc-input"
                                                                placeholder="Enter Description"
                                                                className="w-full"
                                                                name="description"
                                                                value={description}
                                                                onChange={(e) => setDescription(e.target.value)}
                                                            />
                                                        </div>

                                                        {/* Button */}
                                                        <div className="flex justify-content-end mt-3">
                                                            <Button
                                                                className="btn btn-primary"
                                                                label="Save"
                                                                icon="pi pi-save"
                                                                data-testid="edit-save-btn"
                                                                onClick={() => AddNeeds()}
                                                            />
                                                        </div>

                                                    </div>

                                                </Panel>

                                            </div>

                                        </div>
                                )}
                            </div >
                        </Panel >
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OrgEditNeeds
